<template>
  <div class="document-viewer">
    <iframe
      v-if="embedUrl"
      :key="reloadToken + ':' + viewerMode"
      :src="embedUrl"
      width="100%"
      height="100%"
      frameborder="0"
      allowfullscreen
      @load="onIframeLoad"
    />
    <div v-else class="document-viewer__empty">Nenhum arquivo informado.</div>
    <div class="document-viewer__toolbar">
      <span v-if="loading" class="document-viewer__hint">
        Carregando documento... Caso o arquivo seja grande, isto pode levar
        alguns segundos.
      </span>
      <span v-else class="document-viewer__hint">
        Problemas para carregar?
      </span>
      <button
        v-if="canUseOffice"
        type="button"
        class="document-viewer__action"
        @click="switchToOffice"
        :disabled="viewerMode === 'office'"
      >
        Tentar visualizador Office
      </button>
      <button type="button" class="document-viewer__action" @click="reload">
        Recarregar
      </button>
      <a
        v-if="fileUrl"
        class="document-viewer__action"
        :href="fileUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        Abrir em nova aba
      </a>
    </div>
  </div>
</template>

<script>
import buildDocumentEmbedUrl, {
  getFileExtension,
} from "@/shared/buildDocumentEmbedUrl";

const OFFICE_EXTENSIONS = ["ppt", "pptx", "doc", "docx", "xls", "xlsx"];

export default {
  name: "DocumentViewerIframe",
  props: {
    fileUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      viewerMode: "auto",
      loading: true,
      reloadToken: 0,
    };
  },
  computed: {
    embedUrl() {
      return buildDocumentEmbedUrl(this.fileUrl, this.viewerMode);
    },
    canUseOffice() {
      return OFFICE_EXTENSIONS.includes(getFileExtension(this.fileUrl));
    },
  },
  watch: {
    fileUrl() {
      this.viewerMode = "auto";
      this.loading = true;
      this.reloadToken += 1;
    },
  },
  methods: {
    onIframeLoad() {
      this.loading = false;
    },
    switchToOffice() {
      this.viewerMode = "office";
      this.loading = true;
      this.reloadToken += 1;
    },
    reload() {
      this.loading = true;
      this.reloadToken += 1;
    },
  },
};
</script>

<style scoped>
.document-viewer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.document-viewer iframe {
  flex: 1;
  min-height: 60vh;
  border: 1px solid rgba(15, 61, 62, 0.12);
  border-radius: 12px;
}

.document-viewer__empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
}

.document-viewer__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  font-size: 0.85rem;
}

.document-viewer__hint {
  color: #6b7280;
}

.document-viewer__action {
  background: transparent;
  border: 1px solid rgba(15, 61, 62, 0.4);
  border-radius: 8px;
  padding: 4px 10px;
  color: #0f3d3e;
  cursor: pointer;
  font-size: 0.85rem;
  text-decoration: none;
}

.document-viewer__action:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.document-viewer__action:hover:not(:disabled) {
  background: rgba(15, 61, 62, 0.08);
}
</style>
